// extracted by mini-css-extract-plugin
export default {"wrapper":"Dy3QiNYkqX_eMO7yh14z","contentFromRoot":"_MPp51atHRUiwDj9Nkz5","draggableIsOver":"e7592Ieb0JDk9kufnvb8"};